var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPolyline = function SvgPolyline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.25 21.35v-2.054L7.983 15.35H3.85v-4.9h3.666l2.934-3.454V2.65h4.9v4.9h-3.665L8.75 11.004v3.275l6.5 3.525V16.45h4.9v4.9zm-3.5-15.1h2.3v-2.3h-2.3zm-6.6 7.8h2.3v-2.3h-2.3zm11.4 6h2.3v-2.3h-2.3z"
  })));
};
export default SvgPolyline;